import { ReactNode } from 'react'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { ImpersonationBanner } from './ImpersonationBanner'
import { useUIStore } from '@/stores/uiStore'

interface MainLayoutProps {
  children: ReactNode
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  const { sidebarOpen, setSidebarOpen } = useUIStore()

  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex flex-1 flex-col overflow-hidden w-full min-w-0">
        <ImpersonationBanner />
        <Header />
        <main className="flex-1 overflow-y-auto bg-gray-50 p-4 md:p-6 w-full">{children}</main>
      </div>
    </div>
  )
}
